<section class="hero">
  <div class="hero__inner hero__inner--split">
    <div class="hero__content">
      <span class="eyebrow">Din lokala däckexpert sedan 1986</span>
      <h1>Österbydäck &amp; Allservice<span class="hero__partner">En del av <a class="hero__partner-link" href="https://www.firststop.se" target="_blank" rel="noopener">First&nbsp;Stop Sverige</a></span></h1>
      <p class="hero__lead">
        Vi har det mesta inom däck oavsett om det gäller bilar, mc, lastbilar eller skottkärror.
        Vi servar din bil med modern utrustning och teknik &ndash; med originaldelar från
        Autoexperten ingår 3 års garanti på reservdelar.
      </p>
      <div class="hero__actions">
        <a class="action action--primary" routerLink="/contactus">Kontakta oss</a>
        <a class="action action--outline" routerLink="/findus">Hitta hit</a>
      </div>
    </div>

    <div class="hero__anniversary">
      <h2 class="hero__anniversary-title">Vi firar 40 år!</h2>
      <p class="hero__anniversary-text">
        Handla hos oss mellan 1 oktober &ndash; 30 november och delta i vår stora jubileumsutlottning.
        Som kund har du chansen att få tillbaka upp till 10&nbsp;000 kr eller vinna fina tjänster hos oss.
        För att vara med i utlottningen fyller du i formuläret här!
      </p>
      <a class="action action--primary" href="https://form.jotform.com/262726707559065" target="_blank" rel="noopener">Formulär</a>
      <img class="hero__anniversary-img" src="assets/images/Österby_däck_och_allservice_facebook_ballonger_800x710px.png" alt="40-årsjubileum">
    </div>
  </div>
</section>

<div class="page">

  <div class="quick-links">
    <a class="quick-link" routerLink="/service">
      <h2>Service</h2>
      <p>Rutinservice, 4-hjulsmätning och avancerad felsökning. Vi servar hybrider och elbilar.</p>
    </a>
    <a class="quick-link" routerLink="/tires">
      <h2>Däck</h2>
      <p>Brett sortiment i alla prisklasser för alla säsonger.</p>
    </a>
    <a class="quick-link" routerLink="/storage">
      <h2>Däckhotell</h2>
      <p>Trygg förvaring av dina hjul mellan säsongerna.</p>
    </a>
    <a class="quick-link" routerLink="/openinghours">
      <h2>Öppettider</h2>
      <p>Se när vi har öppet och när du kan komma in.</p>
    </a>
  </div>

  <div class="panel promo-card">
    <h2>Aktuella erbjudanden</h2>
    <ngb-carousel #carousel [interval]="60000" [pauseOnHover]="pauseOnHover" (slide)="onSlide($event)">
      @for (img of images; track img; let i = $index) {
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper" [style.background-image]="'url(' + img + ')'">
            <img [src]="img" alt="Erbjudande {{i + 1}}">
          </div>
        </ng-template>
      }
    </ngb-carousel>
  </div>

</div>
